export default __webpack_public_path__ + "assets/62d0bd37c7a8abe4184768f142b2d7fa.svg";